var _g, _path, _mask, _g2, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 77.222 105.59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#925f33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.642 105.59c-1.044 0-1.945-0.217-2.703-0.65-0.755-0.438-1.335-1.057-1.742-1.857-0.406-0.804-0.609-1.75-0.609-2.838 0-1.071 0.203-2.01 0.609-2.819 0.411-0.813 0.985-1.445 1.721-1.897 0.737-0.456 1.601-0.684 2.595-0.684 0.641 0 1.247 0.104 1.816 0.312 0.573 0.203 1.079 0.519 1.517 0.948 0.443 0.429 0.791 0.976 1.044 1.64 0.253 0.659 0.379 1.445 0.379 2.357v0.752h-8.53v-1.653h6.179c-4e-3 -0.47-0.106-0.887-0.305-1.253-0.198-0.371-0.476-0.662-0.833-0.874-0.352-0.212-0.763-0.319-1.233-0.319-0.501 0-0.942 0.122-1.321 0.366-0.38 0.24-0.675 0.556-0.888 0.949-0.207 0.388-0.314 0.815-0.318 1.28v1.443c0 0.606 0.111 1.125 0.332 1.559 0.221 0.429 0.531 0.758 0.928 0.989 0.398 0.226 0.863 0.338 1.396 0.338 0.357 0 0.679-0.049 0.969-0.149 0.289-0.103 0.539-0.255 0.752-0.453 0.212-0.199 0.372-0.445 0.481-0.739l2.29 0.257c-0.145 0.606-0.42 1.134-0.827 1.586-0.402 0.447-0.917 0.795-1.545 1.043-0.628 0.244-1.346 0.366-2.154 0.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.822 105.38v-1.558l5.3659-6.728v-0.088h-5.1898v-2.032h8.1908v1.673l-5.1082 6.612v0.089h5.2842v2.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.122 99.288v6.098h-2.4526v-10.407h2.3442v1.769h0.1219c0.2394-0.583 0.6211-1.046 1.145-1.389 0.5285-0.344 1.1811-0.515 1.958-0.515 0.7181 0 1.3437 0.153 1.8767 0.461 0.5375 0.307 0.953 0.752 1.2466 1.334 0.2981 0.583 0.4449 1.29 0.4403 2.121v6.626h-2.4525v-6.247c0-0.695-0.1807-1.24-0.542-1.633-0.3568-0.393-0.8514-0.589-1.4837-0.589-0.4291 0-0.8108 0.095-1.145 0.285-0.3297 0.185-0.5894 0.453-0.7791 0.806-0.1852 0.352-0.2778 0.779-0.2778 1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.939 105.59c-1.0162 0-1.897-0.224-2.6422-0.671-0.7453-0.447-1.3234-1.072-1.7344-1.876-0.4065-0.804-0.6098-1.744-0.6098-2.819s0.2033-2.016 0.6098-2.825c0.411-0.808 0.9891-1.436 1.7344-1.883 0.7452-0.448 1.626-0.671 2.6422-0.671 1.0163 0 1.897 0.223 2.6423 0.671 0.7453 0.447 1.3211 1.075 1.7276 1.883 0.411 0.809 0.6166 1.75 0.6166 2.825s-0.2056 2.015-0.6166 2.819c-0.4065 0.804-0.9823 1.429-1.7276 1.876s-1.626 0.671-2.6423 0.671zm0.0136-1.965c0.551 0 1.0117-0.151 1.3821-0.454 0.3704-0.307 0.6459-0.718 0.8265-1.233 0.1852-0.515 0.2778-1.088 0.2778-1.721 0-0.636-0.0926-1.212-0.2778-1.727-0.1806-0.52-0.4561-0.933-0.8265-1.24s-0.8311-0.461-1.3821-0.461c-0.5646 0-1.0343 0.154-1.4092 0.461-0.3704 0.307-0.6482 0.72-0.8333 1.24-0.1807 0.515-0.271 1.091-0.271 1.727 0 0.633 0.0903 1.206 0.271 1.721 0.1851 0.515 0.4629 0.926 0.8333 1.233 0.3749 0.303 0.8446 0.454 1.4092 0.454z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.601 105.38v-10.407h2.378v1.735h0.1084c0.1897-0.601 0.5149-1.064 0.9756-1.389 0.4652-0.33 0.9959-0.495 1.5921-0.495 0.1355 0 0.2868 7e-3 0.454 0.021 0.1716 9e-3 0.3139 0.024 0.4268 0.047v2.256c-0.1039-0.036-0.2688-0.068-0.4946-0.095-0.2213-0.031-0.4359-0.047-0.6436-0.047-0.4472 0-0.8492 0.097-1.206 0.291-0.3523 0.19-0.63 0.454-0.8333 0.793s-0.3049 0.729-0.3049 1.172v6.118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5083 105.38v-13.875h5.3116c1.0027 0 1.836 0.158 2.5 0.474 0.6685 0.312 1.1676 0.739 1.4973 1.281 0.3342 0.542 0.5013 1.156 0.5013 1.842 0 0.565-0.1084 1.048-0.3252 1.45-0.2168 0.398-0.5081 0.721-0.874 0.969-0.3658 0.249-0.7746 0.427-1.2262 0.535v0.136c0.4923 0.027 0.9643 0.178 1.4159 0.454 0.4562 0.271 0.8289 0.655 1.1179 1.151 0.2891 0.497 0.4336 1.098 0.4336 1.803 0 0.718-0.1739 1.364-0.5217 1.937-0.3477 0.569-0.8717 1.019-1.5718 1.349-0.7 0.329-1.5808 0.494-2.6422 0.494zm2.5135-2.1h2.7033c0.9123 0 1.5695-0.174 1.9715-0.522 0.4065-0.352 0.6097-0.804 0.6097-1.355 0-0.411-0.1016-0.781-0.3048-1.111-0.2033-0.334-0.4924-0.596-0.8672-0.786-0.3749-0.194-0.8221-0.291-1.3415-0.291h-2.771zm0-5.874h2.4865c0.4336 0 0.8243-0.079 1.172-0.237 0.3478-0.163 0.6211-0.391 0.8198-0.684 0.2033-0.299 0.3049-0.651 0.3049-1.057 0-0.538-0.1897-0.981-0.5691-1.328-0.3749-0.348-0.9327-0.522-1.6734-0.522h-2.5407z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m77.222 38.611c0 21.324-17.287 38.611-38.611 38.611-21.324 0-38.611-17.287-38.611-38.611 0-21.324 17.287-38.611 38.611-38.611 21.324 0 38.611 17.287 38.611 38.611z",
    fill: "url(#paint0_linear_1699_3678)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_3678",
    x: 57,
    y: 28,
    width: 56,
    height: 56,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.12 55.694c0 15.106-12.246 27.352-27.352 27.352s-27.352-12.246-27.352-27.352 12.246-27.352 27.352-27.352 27.352 12.246 27.352 27.352z",
    fill: "#c28b37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.863 -14.537)",
    mask: "url(#mask0_1699_3678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.66 52.778c0 15.106-12.246 27.352-27.353 27.352s-27.352-12.246-27.352-27.352c0-15.106 12.246-27.352 27.352-27.352s27.353 12.246 27.353 27.352z",
    fill: "url(#paint1_linear_1699_3678)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.628 18.289 6.4352 12.87 12.87 1.6088-8.8374 9.9102 2.4024 14.222-12.87-6.4352-12.87 6.4352 2.4239-14.222-8.8591-9.9102 12.87-1.6088z",
    fill: "url(#paint2_linear_1699_3678)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m39.628 16.256 7.0304 14.061 14.105 1.7632-9.6992 10.876 2.6278 15.555-14.064-7.0321-14.067 7.0336 2.6515-15.557-9.7223-10.876 14.108-1.7635zm-6.4352 14.902-12.87 1.6088 8.8592 9.9102-2.424 14.222 12.87-6.4352 12.87 6.4352-2.4025-14.222 8.8377-9.9102-12.87-1.6088-6.4352-12.87z",
    clipRule: "evenodd",
    fill: "#fff",
    fillOpacity: 0.2,
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_3678",
    x1: 83.474,
    x2: 83.474,
    y1: 14.537,
    y2: 91.759,
    gradientTransform: "translate(-44.863 -14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7AB6C",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833C01",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1699_3678",
    x1: 83.308,
    x2: 83.308,
    y1: 25.426,
    y2: 80.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A769",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B46B2E",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1699_3678",
    x1: 84.491,
    x2: 84.491,
    y1: 45.233,
    y2: 69.794,
    gradientTransform: "translate(-44.863 -14.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09657",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardBronze);
export default __webpack_public_path__ + "static/media/reward-bronze.0480af832a94c4e0ff03dc90c2dc28de.svg";
export { ForwardRef as ReactComponent };